import React from 'react';
import ReactDOM from 'react-dom';

import Backdrop from './Backdrop';

import './Modal.scss';
import { Icon } from '@common/Icon/Icon';

interface Props {
    visible: boolean;
    // ``null`` means that the modal can not be closed
    // or only by an interactive element within the modal
    // (used for the ``AgreementConsentModal``)
    toggleVisibility: (() => void) | null;
    nested?: boolean;
    centerHorizontally?: boolean;
    additionalClasses?: string[];
    darkBackdrop?: boolean;
}

const Modal: React.FunctionComponent<Props> = (props) => {
    if (props.visible === false) {
        return null;
    }

    const nested = Boolean(props.nested);
    const centerHorizontally = Boolean(props.centerHorizontally);

    const backdropDomcontainer = document.querySelector('#js-backdrop') as HTMLElement;
    const fullscreenBackdrop = nested
        ? ReactDOM.createPortal(
              <Backdrop
                  visible={props.visible}
                  onClick={props.toggleVisibility ?? (() => undefined)}
                  nested={nested}
                  noOpacity={true}
              />,
              backdropDomcontainer,
          )
        : null;

    let classes = ['lombagine-modal', centerHorizontally ? 'centerHorizontally' : ''];

    if (props.additionalClasses && Array.isArray(props.additionalClasses) && props.additionalClasses.length > 0) {
        classes = classes.concat(props.additionalClasses);
    }

    return (
        <>
            <div className={classes.join(' ')}>
                {props.toggleVisibility ? (
                    <button
                        className="lombagine-modal__close"
                        type="button"
                        aria-label="Dieses Fenster schließen"
                        onClick={props.toggleVisibility}
                    >
                        <Icon icon="close2" />
                    </button>
                ) : null}
                {props.children}
            </div>
            <Backdrop
                visible={props.visible}
                onClick={props.toggleVisibility ?? (() => undefined)}
                nested={nested}
                dark={props.darkBackdrop}
            />
            {fullscreenBackdrop}
        </>
    );
};

export default Modal;
